@if ({}; as STATE) {
  <section class="subscriber-advertiser-card"></section>
}
